import * as React from "react"
const DeletePeakIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 300 300"
    {...props}
  >
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M67.037 223.015q29.462-19.894 38.21-64.827c8.748-44.933 14.584-94.625 30.183-94.625 11.63 0 15.178 27.744 20.558 60.387M155.988 123.95c1.837 11.145 3.887 22.86 6.546 34.238 9.94 42.548 32.648 61.983 61.278 61.983"
      transform="matrix(1.69364 0 0 1.69364 -101.272 -87.049)"
    />
    <path
      fill="none"
      stroke="red"
      strokeWidth={15}
      d="m183.692 82.316 73.316 73.316M257.008 82.316l-73.316 73.316"
    />
  </svg>
)
export default DeletePeakIcon
